<template>
  <c-step
    stepperGrpCd="SAFETY_ACTION_STEP_CD"
    :currentStepCd="currentStepCd"
    :param="param"
    v-model="stepCd"
    @closePopup="closePopup"
    @currentStep="currentStep"
    @stepClick="stepClick"
  >
  </c-step>
</template>

<script>
export default {
  name: 'safety-action-target-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        safetyActionTargetId: '',
        stepCd: '',
        count: 0,
      }),
    },
  },
  data() {
    return {
      editable: true,
      stepCd: '',
      currentStepCd: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  computed: {
    param() {
      return {
        safetyActionTargetId: this.popupParam.safetyActionTargetId,
      }
    },
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.setStep();
    },
    setStep() {
      if (this.popupParam.stepCd === '002' || this.popupParam.stepCd === '003') {
        this.stepCd = 'SASC000002'
        this.currentStepCd = 'SASC000002'
      } else {
        this.stepCd = 'SASC000001'
        this.currentStepCd = 'SASC000001'
      }
    },
    currentStep(step) {
      if (!step || step === '001') {
        this.stepCd = 'SASC000001'
        this.currentStepCd = 'SASC000001'
      } else {
        this.stepCd = 'SASC000002'
        this.currentStepCd = 'SASC000002'
      }
      this.popupParam.stepCd = step;
    },
    closePopup() {
      this.$emit('closePopup')
    },
    stepClick() {
      this.popupParam.count++;
    },
  }
};
</script>
